import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Prompt } from 'react-router-dom';
import ADASelector from '../../components/OfferDetails/ADASelector';
import FlipOfferSelector from '../../components/OfferDetails/FlipOfferSelector';
import { NavigationSteps } from '../../components/OfferDetails/OfferNavigation';
import PropertyInformation from '../../components/OfferDetails/PropertyInformation';
import RoomTypeInformation from '../../components/OfferDetails/RoomTypeInformation';
import SelectOfferHeader from '../../components/OfferDetails/SelectOfferHeader';
import { isSessionExpired } from '../../redux/middleware';
import { RootState } from '../../redux/rootReducer';
import { LOC, PIN } from '../../util/strings';
import {
  releaseHoldProperty,
  resetAllEligibilityOptions,
  resetCurrentAvailabilityDate,
  resetCurrentCalendarPosition,
  resetErrorStatus,
  resetExtraNights,
  resetFinalSelectedDate,
  resetFinalSelectedExtraNights,
  resetNavigationStatus,
  resetNoAvailabilityStatus,
  // eslint-disable-next-line prettier/prettier
  resetOfferMonthRange
} from '../offerAvailability/offerAvailabilitySlice';
import { ReleaseHoldPropertyRequest } from '../offerAvailability/types';
import { resetConfirmationError } from '../offerConfirmation/offerConfirmationSlice';
import { resetGuestsAndState, resetSearchMode, setNavigationStep } from '../offerSearch/offerSearchSlice';
import { OfferDetails, Property } from '../offerSearch/types';
import './OfferDetailsContainer.scss';

const OfferDetailsContainer: FC<any> = (props: any): ReactElement => {
  const offerDetails: OfferDetails = useSelector((state: RootState) => state.offerDetails);
  const holdSessionId = useSelector((state: RootState) => state.availabilityDates.holdSessionId);
  const property: Property | undefined = offerDetails?.property;
  const lastActiveTime = useSelector((state: RootState) => state.sessionManager).lastActiveTime;
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(resetSearchMode(''));
    dispatch(resetErrorStatus());
    dispatch(resetCurrentAvailabilityDate());
    dispatch(resetGuestsAndState());
    dispatch(setNavigationStep(NavigationSteps.OFEFR_DETAILS));
    dispatch(resetNavigationStatus());
    dispatch(resetConfirmationError());
    dispatch(resetNoAvailabilityStatus());
    dispatch(resetExtraNights());
    dispatch(resetAllEligibilityOptions());
    dispatch(resetCurrentCalendarPosition());
    dispatch(resetOfferMonthRange());
    dispatch(resetFinalSelectedDate());
    dispatch(resetFinalSelectedExtraNights());
  }, [dispatch]);

  useEffect(() => {
    if (holdSessionId) {
      const releaseRequest: ReleaseHoldPropertyRequest = {
        holdId: holdSessionId,
      };
      dispatch(releaseHoldProperty(releaseRequest));
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holdSessionId]);

  const pin = offerDetails.searchParameter?.mode === PIN ? offerDetails.searchParameter?.pin : undefined;
  const loc = offerDetails.searchParameter?.mode === LOC ? offerDetails.searchParameter?.pin : undefined;
  const alternateLOC = offerDetails.alternateLOC ? offerDetails.alternateLOC : undefined;
  return (
    <>
      <div className="container wrapSearchOffer">
        <Prompt when={true} message={() => !isSessionExpired(lastActiveTime)}></Prompt>
        <PropertyInformation property={property} />
        <div className="row">
          <div className="col-md-6">
            <SelectOfferHeader />
          </div>
          <div className="col-md-6">
            <ADASelector></ADASelector>
          </div>
        </div>
        <RoomTypeInformation offer={offerDetails.currentOffer} pin={pin} loc={loc} alternateLOC={alternateLOC} />
        <FlipOfferSelector />
      </div>
    </>
  );
};

export default OfferDetailsContainer;
